module.exports = __webpack_public_path__ + "static/logo-841f620e43d7d4aab3eb06d94066f6fa.svg";